<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-card outlined>
          <v-card-text class="info d-flex justify-center">
            <v-img
              class="justify-center"
              :src="'/storage/' + item.image"
              lazy-src="/storage/default_img/no_image.png"
              aspect-ratio="1"
              max-width="100"
              max-height="100"
            />
          </v-card-text>
          <v-card-text>
            Customer Information<br>

            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <th class="text-left">
                      Purchase Date:
                    </th>
                    <td>
                      <v-img
                        class="barcode"
                        :src="item.barcode"
                        lazy-src="/storage/default_img/no_image.png"
                      />
                      {{ item.created_at }}
                    </td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      Customer Name:
                    </th>
                    <td>{{ item.fullName }}</td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      Phone:
                    </th>
                    <td>{{ item.phone }}</td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      Address:
                    </th>
                    <td>{{ item.address }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
        <v-card
          outlined
          class="mt-2"
        >
          <v-card-text>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Device Model
                    </th>
                    <th class="text-left">
                      IMEI
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ item.model }}</td>
                    <td>{{ item.imei }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>

        <v-card
          outlined
          class="mt-2"
        >
          <v-card-text>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Cost
                    </th>
                    <th class="text-left">
                      Price
                    </th>
                    <th class="text-left">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ item.cost | currency }}</td>
                    <td>{{ item.price | currency }}</td>
                    <td>
                      <template v-if="item.isSold">
                        Sold
                      </template>
                      <template v-else>
                        Not Sold
                      </template>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-card outlined>
          <v-card-text>
            <v-col class="pa-5 mb-2">
              <div class="d-flex">
                Customer Signature:
                <v-spacer />
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      v-on="on"
                      @click.prevent="
                        $router.push({
                          name: 'CustomProductForm',
                          params: { id: item.id },
                        })
                      "
                    >
                      <v-icon>
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
              </div>
              <v-img
                :src="item.sign"
                class="sign"
                align="justify-center"
              />
            </v-col>
            <v-btn @click="$router.push({ name: 'CustomProductList' })">
              Back
            </v-btn>
          </v-card-text>
          <v-card-text>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  See Customer Photo
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-img
                    :src="'/storage/' + item.photo"
                    lazy-src="/storage/default_img/no_image.png"
                    aspect-ratio="1"
                    max-width="auto"
                    max-height="auto"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  See Customer Identity Document
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-img
                    :src="'/storage/' + item.docs"
                    lazy-src="/storage/default_img/no_image.png"
                    aspect-ratio="1"
                    max-width="auto"
                    max-height="auto"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      item: {},
    };
  },
  mounted() {
    if (this.$route.params.id) {
      window.axios
        .get("/custom-product/" + this.$route.params.id)
        .then((response) => {
          this.$data.item = response.data.item;
        });
    }
  },
};
</script>
<style type="text/css" scoped="">
.barcode {
  width: 150px;
  height: 15px;
}
</style>
